<template>
  <div id="tank-gauge">
    <div class="liquid--area">
      <div class="liquid--gauge--value"       :style="{ backgroundColor: background, top: ( (1 - percentage) * 10 * zoomRate ) + 'rem', height: ( percentage * 10 * zoomRate ) + 'rem', }"></div>
      <div class="liquid--gauge--upper-limit" :style="{ top: ( ( 1 - upperLimit ) * 10 * zoomRate ) + 'rem' }"  ></div>
      <div class="liquid--gauge--lower-limit" :style="{ top: ( ( 1 - lowerLimit ) * 10 * zoomRate ) + 'rem' }"  ></div>
      <div class="liquid--gauge--back"></div>
      <div class="liquid--ruler-scale--0"></div>
      <div class="liquid--ruler-scale--1"></div>
      <div class="liquid--ruler-scale--2"></div>
      <div class="liquid--ruler-scale--3"></div>
      <div class="liquid--ruler-scale--4"></div>
      <div class="liquid--ruler-scale--5"></div>
      <div class="liquid--ruler-scale--6"></div>
      <div class="liquid--ruler-scale--7"></div>
      <div class="liquid--ruler-scale--8"></div>
      <div class="liquid--ruler-scale--9"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    background: { type: String },
    percentage: { type: Number },
    upperLimit: { type: Number },
    lowerLimit: { type: Number }
  },
  data() {
    return {
      zoomRate: 0.5
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#tank-gauge {
  min-width: 50px;
  max-width: 50px;
  min-height: 70px;
  max-height: 70px;

  .liquid--ruler-scale--0::before {
    content: "";
    border-bottom: 1px solid $aisea-slightly-gray;
    left: 0;
    right: 0;
    /* width: 100%; */
    position: absolute;
    width: calc(7rem * 0.5);
    transform: scaleY(0.5) translateY(3px);
    height: calc(1rem * 0.4);
  }
  .liquid--ruler-scale--1::after {
    content: "";
    border-bottom: 1px solid $aisea-slightly-gray;
    left: 0;
    right: 0;
    /* width: 100%; */
    position: absolute;
    width: calc(7rem * 0.5);
    transform: scaleY(0.5) translateY(3px);
    height: calc(1rem * 0.5);
  }
  .liquid--ruler-scale--2::after {
    content: "";
    border-bottom: 1px solid $aisea-slightly-gray;
    left: 0;
    right: 0;
    /* width: 100%; */
    position: absolute;
    width: calc(7rem * 0.5);
    transform: scaleY(0.5) translateY(3px);
    height: calc(1rem * 0.5);
  }
  .liquid--ruler-scale--3::after {
    content: "";
    border-bottom: 1px solid $aisea-slightly-gray;
    left: 0;
    right: 0;
    /* width: 100%; */
    position: absolute;
    width: calc(7rem * 0.5);
    transform: scaleY(0.5) translateY(3px);
    height: calc(1rem * 0.5);
  }
  .liquid--ruler-scale--5::after {
    content: "";
    border-bottom: 1px solid $aisea-slightly-gray;
    left: 0;
    right: 0;
    /* width: 100%; */
    position: absolute;
    width: calc(7rem * 0.5);
    transform: scaleY(0.5) translateY(3px);
    height: calc(1rem * 0.5);
  }
  .liquid--ruler-scale--6::after {
    content: "";
    border-bottom: 1px solid $aisea-slightly-gray;
    left: 0;
    right: 0;
    /* width: 100%; */
    position: absolute;
    width: calc(7rem * 0.5);
    transform: scaleY(0.5) translateY(3px);
    height: calc(1rem * 0.5);
  }
  .liquid--ruler-scale--7::after {
    content: "";
    border-bottom: 1px solid $aisea-slightly-gray;
    left: 0;
    right: 0;
    /* width: 100%; */
    position: absolute;
    width: calc(7rem * 0.5);
    transform: scaleY(0.5) translateY(3px);
    height: calc(1rem * 0.5);
  }
  .liquid--ruler-scale--8::after {
    content: "";
    border-bottom: 1px solid $aisea-slightly-gray;
    left: 0;
    right: 0;
    /* width: 100%; */
    position: absolute;
    width: calc(7rem * 0.5);
    transform: scaleY(0.5) translateY(3px);
    height: calc(1rem * 0.5);
  }

  .liquid {
    &--area {
      position: relative;
    }
    $zoom_rate: 0.5;
    $cell_height: calc(1rem * #{$zoom_rate});
    $cell_width: calc(7rem * #{$zoom_rate});
    $gauge_width: calc(3rem * #{$zoom_rate});
    &--gauge {
      $left: calc((#{$cell_width} - #{$gauge_width}) / 2);
      $default_guage_value: 5;
      &--value {
        position: absolute;
        top: calc(#{$cell_height} * (10 - #{$default_guage_value}));
        left: $left;
        z-index: 991;
        background-color: $aisea-light-blue;
        height: calc(#{$cell_height} * #{$default_guage_value});
        width: $gauge_width;
      }
      &--upper-limit {
        position: absolute;
        top: calc(#{$cell_height} * 1);
        z-index: 993;
        width: $cell_width;
        border-bottom: 1px solid $aisea-red;
      }
      &--lower-limit {
        position: absolute;
        top: calc(#{$cell_height} * 9);
        z-index: 992;
        width: $cell_width;
        border-bottom: 1px solid $aisea-black;
      }
      &--back {
        position: absolute;
        left: $left;
        top: 0;
        z-index: 990;
        background-color: $aisea-slightly-gray;
        height: calc(#{$cell_height} * 10);
        width: $gauge_width;
      }
    }
    &--ruler-scale {
      &--0 {
        position: absolute;
        top: calc(#{$cell_height} * 0);
        width: $cell_width;
        height: $cell_height;
        border-top: 1px solid $aisea-slightly-gray;
      }
      &--1 {
        position: absolute;
        top: calc(#{$cell_height} * 1);
        width: $cell_width;
        height: $cell_height;
      }
      &--2 {
        position: absolute;
        top: calc(#{$cell_height} * 2);
        width: $cell_width;
        height: $cell_height;
      }
      &--3 {
        position: absolute;
        top: calc(#{$cell_height} * 3);
        width: $cell_width;
        height: $cell_height;
      }
      &--4 {
        position: absolute;
        top: calc(#{$cell_height} * 4);
        width: $cell_width;
        height: $cell_height;
        border-bottom: 1px solid $aisea-slightly-gray;
      }
      &--5 {
        position: absolute;
        top: calc(#{$cell_height} * 5);
        width: $cell_width;
        height: $cell_height;
      }
      &--6 {
        position: absolute;
        top: calc(#{$cell_height} * 6);
        width: $cell_width;
        height: $cell_height;
      }
      &--7 {
        position: absolute;
        top: calc(#{$cell_height} * 7);
        width: $cell_width;
        height: $cell_height;
      }
      &--8 {
        position: absolute;
        top: calc(#{$cell_height} * 8);
        width: $cell_width;
        height: $cell_height;
      }
      &--9 {
        position: absolute;
        top: calc(#{$cell_height} * 9);
        width: $cell_width;
        height: $cell_height;
        border-bottom: 1px solid $aisea-slightly-gray;
      }
    }
  }
}
</style>